import ClientInstance from 'api/ClientInstance';

interface IUserEndpoints {
  getUser: any;
  putUser: any;
  reinvite: any;
}

const userEndpoints: IUserEndpoints = {
  getUser: (params: any = {}) => ClientInstance.get('/users', { params }),
  putUser: (body: any) => ClientInstance.put('/users', body),
  reinvite: (body: any) => ClientInstance.post('/users/confirmations', body),
};

export default userEndpoints;
